import { cn } from "@/lib/utils";
import { FieldIconButton } from "@patient-watch/ui";
import { Input } from "@patient-watch/ui/input";
import { Search, X } from "lucide-react";

interface AppSearchInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder: string;
    "aria-label": string;
    clearAriaLabel?: string;
    id?: string;
    className?: string;
    /** `xs` matches the analytics tab bar (`h-12`). Default stays the standard input height. */
    inputSize?: "xs" | "sm" | "md";
}

/**
 * Search field used on list pages (templates, studies, etc.).
 * Width stays fixed. Growing it on focus reflows the toolbar and can crash the tab.
 */
export function AppSearchInput({
    value,
    onChange,
    placeholder,
    "aria-label": ariaLabel,
    clearAriaLabel = "Clear search",
    id,
    className,
    inputSize,
}: AppSearchInputProps) {
    return (
        <div className={cn("relative w-[min(100%,15rem)] shrink-0 min-w-0 max-w-full", className)}>
            <Search
                size={16}
                className="top-1/2 left-3 absolute text-slate-500 dark:text-slate-300 -translate-y-1/2 pointer-events-none"
                aria-hidden
            />
            <Input
                id={id}
                placeholder={placeholder}
                value={value}
                onChange={(event) => onChange(event.target.value)}
                inputSize={inputSize}
                className="bg-slate-50/50 pr-9 pl-9 w-full text-slate-800 placeholder:text-slate-500"
                aria-label={ariaLabel}
            />
            {value ? (
                <FieldIconButton
                    onClick={() => onChange("")}
                    className="top-1/2 right-1.5 absolute -translate-y-1/2"
                    aria-label={clearAriaLabel}
                >
                    <X />
                </FieldIconButton>
            ) : null}
        </div>
    );
}
